// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldTimerPause = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '25',
      height: '24',
      viewBox: '0 0 25 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.3906 3.45H9.61062C9.21062 3.45 8.89062 3.13 8.89062 2.73C8.89062 2.33 9.21062 2 9.61062 2H15.3906C15.7906 2 16.1106 2.32 16.1106 2.72C16.1106 3.12 15.7906 3.45 15.3906 3.45Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.5001 19.9684V17.0284C14.5001 15.2184 15.7201 13.9984 17.5301 13.9984H20.4701C20.7001 13.9984 20.9201 14.0184 21.1301 14.0584C21.1501 13.8184 21.1701 13.5784 21.1701 13.3284C21.1701 8.53844 17.2801 4.64844 12.5001 4.64844C7.72008 4.64844 3.83008 8.53844 3.83008 13.3284C3.83008 18.1084 7.72008 21.9984 12.5001 21.9984C13.3501 21.9984 14.1601 21.8584 14.9401 21.6384C14.6601 21.1684 14.5001 20.6084 14.5001 19.9684ZM13.2501 12.9984C13.2501 13.4084 12.9101 13.7484 12.5001 13.7484C12.0901 13.7484 11.7501 13.4084 11.7501 12.9984V7.99844C11.7501 7.58844 12.0901 7.24844 12.5001 7.24844C12.9101 7.24844 13.2501 7.58844 13.2501 7.99844V12.9984Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.47 15H17.54C16.26 15 15.5 15.76 15.5 17.03V19.97C15.5 21.24 16.26 22 17.54 22H20.47C21.74 22 22.5 21.24 22.5 19.97V17.03C22.5 15.76 21.74 15 20.47 15ZM18.42 20.06C18.42 20.38 18.16 20.64 17.83 20.64C17.51 20.64 17.25 20.38 17.25 20.06V16.94C17.25 16.62 17.51 16.36 17.83 16.36C18.16 16.36 18.42 16.62 18.42 16.94V20.06ZM20.75 20.06C20.75 20.38 20.49 20.64 20.17 20.64C19.85 20.64 19.58 20.38 19.58 20.06V16.94C19.58 16.62 19.85 16.36 20.17 16.36C20.49 16.36 20.75 16.62 20.75 16.94V20.06Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldTimerPause };
